import {useCallback, useMemo, useState} from "react";
import {useSiren} from "../SirenContext";
import {platformAPI} from "../../../api/axiosConfig";
import {useNavigateWithClientID} from "./useNavigateWithClientID";
import {Contact} from "../typedefs";
import {useNavigate} from "react-router-dom";

export function useEditContact(contact: Contact, redirect: string | null) {
    const {setToast} = useSiren();

    const [firstName, setFirstName] = useState(contact.firstName);
    const [lastName, setLastName] = useState(contact.lastName);
    const [phoneMobileWork, setPhoneMobileWork] = useState(contact.phoneMobileWork?.e164 ?? "");
    const [phoneMobilePersonal, setPhoneMobilePersonal] = useState(contact.phoneMobilePersonal?.e164 ?? "");
    const [phoneHome, setPhoneHome] = useState(contact.phoneHome?.e164 ?? "");
    const [emailWork, setEmailWork] = useState(contact.emailWork);
    const [emailPersonal, setEmailPersonal] = useState(contact.emailPersonal);
    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();
    const {navigateWithClientID} = useNavigateWithClientID();

    const request = useMemo(() => ({
        firstName, lastName, phoneMobileWork, phoneMobilePersonal, phoneHome, emailWork, emailPersonal,
    }), [firstName, lastName, phoneMobileWork, phoneMobilePersonal, phoneHome, emailWork, emailPersonal]);

    const submit = useCallback(async () => {
        setIsLoading(true);
        try {
            await platformAPI.patch(`api/contacts/${contact.id}`, request);
            setToast("Contact updated", "success");
            if (redirect) {
                navigate(redirect);
                return;
            }
            navigateWithClientID("/siren/contacts");
        } finally {
            setIsLoading(false);
        }
    }, [request, redirect]);

    return {
        firstName, setFirstName,
        lastName, setLastName,
        phoneMobileWork, setPhoneMobileWork,
        phoneMobilePersonal, setPhoneMobilePersonal,
        phoneHome, setPhoneHome,
        emailWork, setEmailWork,
        emailPersonal, setEmailPersonal,
        isLoading,
        submit,
    };
}
